import React from "react";
import { Box, Typography, Paper, Button, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLista } from "../hooks/useListe";
import { useFormEvento } from "../hooks/useFormEvento";
import SezioneBase from "../components/form/SezioneBase";
import SezionePiattaforma from "../components/form/SezionePiattaforma";
import SezioneDR from "../components/form/SezioneDR";
import SezioneRegistrazione from "../components/form/SezioneRegistrazione";
import SezioneDEM from "../components/form/SezioneDEM";
import SezioneRiferimenti from "../components/form/SezioneRiferimenti";
import SezioneStato from "../components/form/SezioneStato";
import SezionePreventivo from "../components/form/SezionePreventivo";
import PersonaleEvento from "../components/PersonaleEvento";
import CostiEvento from "../components/CostiEvento";
import ReferentiEvento from "../components/ReferentiEvento";
import AnalisiCostiRicavi from "../components/AnalisiCostiRicavi";

export default function FormEvento() {
  const navigate = useNavigate();

  const { items: clienti, loading: loadingClienti, aggiungiItem: aggiungiCliente } = useLista("clienti");
  const { items: tecnologie, loading: loadingTecnologie, aggiungiItem: aggiungiTecnologia } = useLista("tecnologie");
  const { items: piattaformeStudio, loading: loadingStudio, aggiungiItem: aggiungiStudio } = useLista("piattaformeStudio");
  const { items: piattaformeDistr, loading: loadingDistr, aggiungiItem: aggiungiDistr } = useLista("piattaformeDistribuzione");
  const { items: tipologieEvento, loading: loadingTipologie, aggiungiItem: aggiungiTipologia } = useLista("tipologieEvento");
  const { items: direzioni, loading: loadingDirezioni, aggiungiItem: aggiungiDirezione } = useLista("direzioni");
  const { items: canaliDR, loading: loadingCanali, aggiungiItem: aggiungiCanale } = useLista("canaliDR");

  const {
    id, form, loading, saving,
    handleChange, toggleMultiple, handleDurataGiorni, handleGiornata, handleArea, handleSalva,
    creaDriveManuale, handleElimina,
  } = useFormEvento(clienti);

  if (loading) return <Box display="flex" justifyContent="center" mt={8}><CircularProgress /></Box>;

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" mb={3}>
        {id ? "Modifica Evento" : "Nuovo Evento"}
      </Typography>

      <SezionePreventivo
        form={form}
        handleChange={handleChange}
        handleArea={handleArea}
      />

      <SezioneBase
        form={form} handleChange={handleChange}
        handleDurataGiorni={handleDurataGiorni} handleGiornata={handleGiornata}
        clienti={clienti} loadingClienti={loadingClienti} aggiungiCliente={aggiungiCliente}
        tipologieEvento={tipologieEvento} loadingTipologie={loadingTipologie} aggiungiTipologia={aggiungiTipologia}
        onCreaDriveManuale={creaDriveManuale}
      />

      <SezionePiattaforma
        form={form} handleChange={handleChange}
        tecnologie={tecnologie} loadingTecnologie={loadingTecnologie} aggiungiTecnologia={aggiungiTecnologia}
        piattaformeStudio={piattaformeStudio} loadingStudio={loadingStudio} aggiungiStudio={aggiungiStudio}
        piattaformeDistr={piattaformeDistr} loadingDistr={loadingDistr} aggiungiDistr={aggiungiDistr}
      />

      <SezioneDR
        form={form} handleChange={handleChange}
        canaliDR={canaliDR} loadingCanali={loadingCanali} aggiungiCanale={aggiungiCanale}
      />

      <SezioneRegistrazione form={form} toggleMultiple={toggleMultiple} />

      <SezioneDEM form={form} handleChange={handleChange} />

      <SezioneRiferimenti
        form={form} handleChange={handleChange}
        direzioni={direzioni} loadingDirezioni={loadingDirezioni} aggiungiDirezione={aggiungiDirezione}
        clienti={clienti}
      />

      <SezioneStato form={form} handleChange={handleChange} />

      {id && ["chiusoAcquisito", "completato", "fatturato"].includes(form.stato) && (
        <>
          <Paper elevation={1} sx={{ p: 3, mb: 2 }}>
            <ReferentiEvento eventoId={id} />
          </Paper>
          <Paper elevation={1} sx={{ p: 3, mb: 2 }}>
            <PersonaleEvento eventoId={id} />
          </Paper>
          <Paper elevation={1} sx={{ p: 3, mb: 2 }}>
            <CostiEvento eventoId={id} />
          </Paper>
          <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
            <AnalisiCostiRicavi eventoId={id} form={form} handleChange={handleChange} />
          </Paper>
        </>
      )}

      <Box display="flex" justifyContent="space-between" gap={2}>
        <Box>
          {id && ["qualificazione", "preventivo"].includes(form.stato) && (
            <Button variant="outlined" color="error" onClick={handleElimina}>
              Elimina evento
            </Button>
          )}
        </Box>
        <Box display="flex" gap={2}>
          <Button variant="outlined" onClick={() => navigate("/")}>Annulla</Button>
          <Button variant="contained" onClick={handleSalva} disabled={saving}>
            {saving ? <CircularProgress size={20} /> : "Salva"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}